import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getImage } from '../utils/imageImports';

export default function AppFooter() {
  const { t } = useTranslation();

  const footerSections = [
    {
      title: t('navigation.features'),
      items: [
        { text: t('navigation.features-list.email-testing'), to: '/features/email-design-testing' },
        { text: t('navigation.features-list.email-analytics'), to: '/features/email-analytic' },
        { text: t('navigation.features-list.spam-testing'), to: '/features/inbox-spam-testing' },
        { text: t('navigation.features-list.white-label-api'), to: '/features/white-label-api' },
        // { text: t('navigation.features-list.email-editor'), to: '/features/email-editor' },
      ],
    },
    {
      title: t('navigation.resources'),
      items: [
        { text: t('navigation.what-email'), to: '/articles/what-is-email-testing' },
      ],
    },
    {
      title: t('navigation.company'),
      items: [
        { text: t('navigation.about'), to: '/about' },
        { text: t('navigation.contacts'), to: '/contact' },
        { text: t('navigation.terms-of-user'), to: '/policy/terms' },
        { text: t('navigation.privacy-policy'), to: '/policy/privacy' },
      ],
    },
  ];

  return (
    <Box 
      component="footer" 
      sx={{ 
        width: '100%',
        bgcolor: 'background.paper',
        mt: 'auto'
      }}
    >
      <Divider />
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '100%',
          width: '100%',
          px: { xs: 2, sm: 3, md: 4 },
          py: 6
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            mx: 'auto',
            width: '100%'
          }}
        >
          <Grid container spacing={4} justifyContent="space-between">
            {footerSections.map((section) => (
              <Grid size={{xs: 12, sm: 6, md: 3}} key={section.title}>
                <Typography variant="h6" gutterBottom>
                  {section.title}
                </Typography>
                <Stack spacing={1}>
                  {section.items.map((item) => (
                    <Link
                      key={item.to}
                      component={RouterLink}
                      to={item.to}
                      color="text.secondary"
                      sx={{ textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
                    >
                      {item.text}
                    </Link>
                  ))}
                </Stack>
              </Grid>
            ))}

            <Grid size={{xs: 12, sm: 6, md: 3}}>
              <Typography variant="h6" gutterBottom>
                {t('contacts')}
              </Typography>
              <Stack spacing={1}>
                <Typography variant="body2" color="text.secondary">
                  {t('address')}: {t('address-info')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('email-address')}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Divider />
      <Box sx={{ width: '100%', bgcolor: '#2a3447', py: 2 }}>
        <Container maxWidth={false} sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3, md: 4 } }}>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid>
              <Link component={RouterLink} to="/">
                <Box 
                  component="img"
                  src={getImage('logo')}
                  alt="EPS Logo"
                  sx={{ 
                    height: 36,
                    width: 202,
                    display: 'block'
                  }}
                />
              </Link>
            </Grid>
            <Grid sx={{ ml: 1 }}>
              <Typography variant="body2" sx={{ color: '#fff' }}>
                {t('copyright')} {new Date().getFullYear()} {t('copyright-text')}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
